module.exports = __webpack_public_path__ + "static/assets/0c0835e8f7ea9a6b5218011527d96727.svg";